export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5468.e43300b6.jpg";